import { generateContext, useSort } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React, { useContext } from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const { StateContext, Provider } = generateContext()
export const useFormSendsState = () => useContext(StateContext)
export const useFormSends = () => useContext(StateContext).formSends

const QUERY = gql`
  query FormSends($page: Int, $limit: Int, $sort: FormSendSort, $filter: FormSendFilter) {
    formSends(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      id
      placeIds
      sentCount
      repliesCount
      insertedAt
    }
  }
`

const FormSendsLoader = ({ children, perPage: limit, uncontrolledChildren }) => {
  const { data: form } = useCurrentModal()
  const { field, type } = useSort()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { formIds: form }
    },
    client: formsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default FormSendsLoader
